<template>
    <div> 
        <div class="newsDetail-divider">
            <div class="tab-title ">{{title}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: '',
        data() {
            return {
                
            }
        },
        props:['title']
    }
</script>

<style lang="scss" scoped>
    .newsDetail-divider{
        // border-bottom:2px solid #E4E7ED;
        overflow: hidden;
        position: relative;
    }
    .newsDetail-divider::after{
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: #E4E7ED;
        z-index: 1;
    }
    
    .tab-title{
        color:#2930f2 ;
        font-size: 16px;
        float: left;
        border-bottom: 3px solid #2930f2;
        line-height: 40px;
        position: relative;
        top: 1px;
        z-index: 2;

    }
</style>